var mdApp = angular.module('MiskowskiDesign', ['monospaced.elastic']);

jQuery( document ).ready( function( $ ) {
	
	var body = $('body');
	/***********************************
	* Testimonials Slider
	************************************/
	var $_testimonials_slider = $('.testimonials-slider');
	if( $_testimonials_slider.length ){

		$_testimonials_slider.slick({
			slidesToShow: 1,
	  		// adaptiveHeight: true,
	  		arrows : false,
	  		dots:true
		});

	}

	/***********************************
	* Logs Masks and Tiles
	************************************/

	var $_logo_tile = $('.logo-tile');
	if( $_logo_tile.length ){
		var $_logos_and_symbol_slider = $('.logos-and-symbol-slider');
		var $_modal_close_btn = $('.modal-close-button');

		$_logo_tile.on('click' , function(){
			var slide_index = $(this).data('slide-id');
			// $('#logos-marks-and-symbol-modal').modal('show');
			$_logos_and_symbol_slider.slick( 'slickGoTo', slide_index  ); // Go to Specific slide :- Selected one

		})

		$('#logos-marks-and-symbol-modal').on('shown.bs.modal', function (e) {
			$_logos_and_symbol_slider.resize();
			$('.slick-next.slick-arrow').focus();
		})
		
		$('.logos-and-symbol-slider').slick({
			slidesToShow: 1,
	  		adaptiveHeight: true,
	  		arrows : true
		});
		
		// $_modal_close_btn.on('click')
	}
	
	/********************************
	*	 Hero Section and Footer Index Shufller
	*********************************/
	// $hero_section
	var zIndex = 1;
	function index_shuffler(){
		// console.log('hello world');
		var $_hero_section = $('.hero-section');
		var $_footer = $('#footer')[0];
		// var footerHeight = $_footer.clientHeight + 30;
		if( $_hero_section.hasClass('bg-image') ){
			return
		}
		var hero_section_height = $_hero_section.outerHeight();
		if ( (document.body.scrollTop > hero_section_height && zIndex == 1) || (document.body.scrollTop <= hero_section_height && zIndex == -1) ) {
			zIndex = zIndex*-1;
			if( $_hero_section.length )
				$_hero_section.css({zIndex:zIndex});
			// $_hero_section.style.zIndex = zIndex;
		}
	}

	window.addEventListener('scroll', index_shuffler);
	window.addEventListener('resize', index_shuffler);



	var arrow = $('.hero-jump');
	arrow.on('click', function(){
		var $_hero_section = $('.hero-section');
		// console.log($('.hero-section').css("margin-top"));
		TweenLite.to( body, 1, { scrollTop: $_hero_section.outerHeight() + parseInt( $_hero_section.css("margin-top" ) ) } );
	});

	// $('.clients-grid-container').on('click' , function(){
	// 	var tl = new TimelineMax();
		
	// 	tl.staggerFromTo( $('.client-item img') , 1 , {transform:"translateY(-15px)" , autoAlpha:0} , { transform:"translateY(0px)" , autoAlpha:1 , ease: Power1.easeInOut }, 0.2 );
	// })




	function init_function(){

		var $_hero_section = $('.hero-section');
		if( $_hero_section.length ){
			var body_class = ( $_hero_section.hasClass('bg-video') ) ? "has-bg-video-in-hero-section" : "has-bg-image-in-hero-section";
			body.addClass(body_class);
		}
		
		$('video').attr('controlsList' , 'nodownload').attr('disablePictureInPicture' , 'true');

	}
	init_function();

	if( body.hasClass('page-template-template-start-a-project') ){
		$(".wpcf7").on( 'wpcf7:mailsent', function( event ){
		    // console.log( 'jQuery submit fire...' );
		    // console.log( event );
			// var thanks = "<div class='thanks-for-contacting form-header'><h1 class='timepose-bold'></h1></div>";
		    $('.contact-us-container').
		    html("<div class='thanks-for-contacting form-header'><div class='hoboken-logo nm'><img src='" + js_data.hoboken_logo +"' alt='Hoboken Logo'></div><h1 class='timepose-bold'>Thanks for contacting us.<br />We’ll be in touch soon!</h1></div>");
		    $('html, body').animate({scrollTop:0},500);
		});
	}

	$(".logo-tile").on({
	    mouseenter: remove_gs_from_svg,
	    mouseleave: make_gs_of_svg,
	    touchstart: remove_gs_from_svg,
	    touchend: make_gs_of_svg 
	});

	function remove_gs_from_svg(){
		$(this).removeClass('g-fill');
	    $(this).css({backgroundColor:$(this).data('bg-color')});
	}
	function make_gs_of_svg(){
		$(this).addClass('g-fill');
	    $(this).css({backgroundColor:''});
	}



	var $_video_container = $('.video-c');
	$_video_container.on('click' , function(){
		// console.log("hello world");
		if( $(this).hasClass("video-playing") ){
			$(this).find('video').trigger('pause');
			$(this).removeClass('video-playing');
		}else{
			$(this).addClass('video-playing');
			$(this).find('video').trigger('play');
		}
	})

	var $_setps = $('.step');
	// $_setps.on('mouseenter' , function(){
	// 	var gif = $(this).find('.step-logo').data('gif');
	// 	$(this).find('.step-logo img:first').attr('src',gif);
	// 	console.log(gif);
	// })
	
	function step_animation_play(){
		var gif = $(this).find('.step-logo').data('gif-play');
		$(this).find('.step-logo img:first').attr('src',gif);
		console.log(gif);	
	}
	function step_animation_reverse(){
		var gif = $(this).find('.step-logo').data('gif-reverse');
		$(this).find('.step-logo img:first').attr('src',gif);
		console.log(gif);	
	}
	
	$_setps.on({
		mouseenter: step_animation_play,
	    // mouseleave: step_animation_reverse,
	    touchstart: step_animation_play,
	    // touchend: step_animation_reverse
	})
	$(".back-to-top").click(function () {
	   $("html, body").animate({scrollTop: 0}, 1000);
	});
	$('textarea.autoExpand').autoResize();
	// Applied globally on all textareas with the "autoExpand" class
	// $(document)
	// .on('focus.autoExpand', 'textarea.autoExpand', function(){
	//     var savedValue = this.value;
	//     this.value = '';
	//     this.baseScrollHeight = this.scrollHeight;
	//     this.value = savedValue;
	// })
	// .on('input.autoExpand', 'textarea.autoExpand', function(){
	// 	// console.log('expend');
	//     var minRows = this.getAttribute('data-min-rows')|0, rows;
	//     this.rows = minRows;
	//     rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 16);
	//     // console.log(rows);
	//     this.rows = minRows + rows;
	// });
	var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)
	if( isSafari ){
		body.addClass('safari-browser');
	}
	
	var $_images_slider = $('.images-slider');
	// console.log( 'new site' );
	if( $_images_slider.length ){
		$_images_slider.slick({
			arrows: true,
			dots: true,
			adaptiveHeight: true,
			fade: true,
			responsive: [
				{
				  	breakpoint: 768,
					settings: {
						dots: false
					}
				},
				{
					breakpoint: 400,
				  	settings: {
						dots : false
				  	}
			  	}
			]	
		});
	}

	function scrollbarWidth() {
		var div = $('<div style="width:50px;height:50px;overflow:hidden;position:absolute;top:-200px;left:-200px;"><div style="height:100px;"></div>');
		// Append our div, do our calculation and then remove it
		$('body').append(div);
		var w1 = $('div', div).innerWidth();
		div.css('overflow-y', 'scroll');
		var w2 = $('div', div).innerWidth();
		$(div).remove();
		return (w1 - w2);
	}

	function setFFWsectionWidth(){
		var sbwidth = scrollbarWidth() / 2;
		$('.force-full-width').css( 'width', "calc( 100vw - " + sbwidth +"px )" );
	}

	setFFWsectionWidth();

	$(window).on( 'resize', function(){
		console.log( scrollbarWidth() / 2 );
		setFFWsectionWidth();
	} );

	// a[href^="#"]
	$('a[href=#landingpage-form]').on('click', function(e) {
			// target element id
			var id = $(this).attr('href');
		
			// target element
			var $id = $(id);
			if ($id.length === 0) {
				return;
			}
		
			// prevent standard hash navigation (avoid blinking in IE)
			e.preventDefault();
		
			// top position relative to the document
			var pos = $id.offset().top;
		
			// animated top scrolling
			$('body, html').animate({scrollTop: pos});
		});

	});



(function($){
    
    $.fn.autoResize = function(options) {
        
        // Just some abstracted details,
        // to make plugin users happy:
        var settings = $.extend({
            onResize : function(){},
            animate : true,
            animateDuration : 150,
            animateCallback : function(){},
            extraSpace : 20,
            limit: 1000
        }, options);
        
        // Only textarea's auto-resize:
        this.filter('textarea').each(function(){
            
                // Get rid of scrollbars and disable WebKit resizing:
            var textarea = $(this).css({resize:'none','overflow-y':'hidden'}),
            
                // Cache original height, for use later:
                origHeight = textarea.height(),
                
                // Need clone of textarea, hidden off screen:
                clone = (function(){
                    
                    // Properties which may effect space taken up by chracters:
                    var props = ['height','width','lineHeight','textDecoration','letterSpacing'],
                        propOb = {};
                        
                    // Create object of styles to apply:
                    $.each(props, function(i, prop){
                        propOb[prop] = textarea.css(prop);
                    });
                    
                    // Clone the actual textarea removing unique properties
                    // and insert before original textarea:
                    return textarea.clone().removeAttr('id').removeAttr('name').css({
                        position: 'absolute',
                        top: 0,
                        left: -9999
                    }).css(propOb).attr('tabIndex','-1').insertBefore(textarea);
					
                })(),
                lastScrollTop = null,
                updateSize = function() {
					
                    // Prepare the clone:
                    clone.height(0).val($(this).val()).scrollTop(10000);
					
                    // Find the height of text:
                    var scrollTop = Math.max(clone.scrollTop(), origHeight) + settings.extraSpace,
                        toChange = $(this).add(clone);
						
                    // Don't do anything if scrollTip hasen't changed:
                    if (lastScrollTop === scrollTop) { return; }
                    lastScrollTop = scrollTop;
					
                    // Check for limit:
                    if ( scrollTop >= settings.limit ) {
                        $(this).css('overflow-y','');
                        return;
                    }
                    // Fire off callback:
                    settings.onResize.call(this);
					
                    // Either animate or directly apply height:
                    settings.animate && textarea.css('display') === 'block' ?
                        toChange.stop().animate({height:scrollTop}, settings.animateDuration, settings.animateCallback)
                        : toChange.height(scrollTop);
                };
            
            // Bind namespaced handlers to appropriate events:
            textarea
                .unbind('.dynSiz')
                .bind('keyup.dynSiz', updateSize)
                .bind('keydown.dynSiz', updateSize)
                .bind('change.dynSiz', updateSize);
            
        });
        
        // Chain:
        return this;
        
    };
})(jQuery);
